export const mgPlatformAddIcon = {
  data: `<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1V13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 7H1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'add'
}
